import { z } from "zod"

export const accountSchema = z.object({
  firstName: z.string().min(3, "First name must be at least 3 characters long"),
  lastName: z.string().min(2, "Last name must be at least 2 characters long"),
})
